import { BaseEntity } from "yt-ng-framework";

export class FakDokument extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavkaID: number = null;
    KomitentID: number = null;
    NacinPlacanjaID: number = null;
    Broj: string = null;
    Datum: Date = null;
    BrojOtpremnice: string = null;
    DatumOtpremnice: Date = null;
    DatDpo: Date = null;
    Napomena: string = "";
    NapomenaZaPdvOsl: string = null;
    DatumPrometaOd: Date = null;
    DatumPrometaDo: Date = null;
    Url: string = null;
    RokVazenja: Date = null;
    OdgovornoLiceID: number = null;
    KomitentObjekatID: number = null;
    Dani: number = null;
    MasterDokumID: number = null;
    UplacenAvansOsnovica: number = null;
    PdvNaIznosAvansa: number = null;
    Avansi:string = null;
    DaniVazenja: number = null;
    BrojDokumenta: string = null;
    GenericName: string = null;
    PoreskoOslobodjenjeID: number = null;
    VrstaDatumaPoreskeObavezeID: number=null;
    BrojUgovora: string = null;
    BrojNarudzbenice: string = null;
    ZaCrf: boolean = false;
    ProvajderID: number=null;
    OsvezivogStatusa: boolean= null;
    MestoIsporukeRobe: string = null;
    MestoIzvrseneUsluge: string = null;
    PakovanjeKolicina: number = null;
    PakovanjeVrsta: string = null;
    TezinaNeto: number = null;
    TezinaNetoJedinicaMereId: number = null;
    TezinaBruto: number = null;
    TezinaBrutoJedinicaMereId: number = null;
    Zapremina: number = null;
    ZapreminaJedinicaMereId: number = null;
    BrojPrijemnice: string = null;
    DatumPrijemnice: Date = null;
    DatumNarudzbenice: Date = null;
    ReferencaKupcaNaDrugiDokument: string = null;
    //InterniBrojZaRutiranje: string = null;
    KontaktOsoba: string = null;
    KorekcijaVrednostiDokumenta: number = 0;
    StatusColor: string = null;
    BrojDecimala: string = null;
    UkBrPovezanihDokumenata: number = 0;
    DatumUgovora: Date = null;
    Pozicija: string = null;
    Crm: string = null;
    Vozac: string = null;
    NapomenaTransporteri: string = null;
    VozilaIds: string = null;
    Komentar: string = null;
    UkupnoAvansi: number = null;
    Izvodi: number = null;
    Naplaceno: number = null;
    zaUplatu: number = null;
    DatumSmanjenja: Date = null;
    StatusTooltip: string = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.ID = input.ID;
        // this.Useridlk = input.useridlk;
        // this.Datetimelk = input.datetimelk;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.KomitentID = input.KomitentID;
        this.NacinPlacanjaID = input.NacinPlacanjaID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.BrojOtpremnice = input.BrojOtpremnice;
        this.DatumOtpremnice = input.DatumOtpremnice;
        this.DatDpo = input.DatDpo;
        this.Napomena = input.Napomena != null ? input.Napomena.trim() : input.Napomena;
        this.NapomenaZaPdvOsl = input.NapomenaZaPdvOsl;
        this.DatumPrometaOd = input.DatumPrometaOd;
        this.DatumPrometaDo = input.DatumPrometaDo;
        this.RokVazenja = input.RokVazenja;
        this.OdgovornoLiceID = input.OdgovornoLiceID;
        this.KomitentObjekatID = input.KomitentObjekatID;
        this.Dani = input.Dani;
        this.MasterDokumID = input.MasterDokumID;
        this.UplacenAvansOsnovica = input.UplacenAvansOsnovica;
        this.PdvNaIznosAvansa = input.PdvNaIznosAvansa;
        this.Avansi = input.Avansi;
        this.DaniVazenja = input.DaniVazenja;
        this.BrojDokumenta = input.BrojDokumenta;
        this.GenericName = input.GenericName;
        this.PoreskoOslobodjenjeID = input.PoreskoOslobodjenjeID;
        this.VrstaDatumaPoreskeObavezeID=input.VrstaDatumaPoreskeObavezeID;
        this.BrojUgovora = input.BrojUgovora;
        this.BrojNarudzbenice = input.BrojNarudzbenice;
        this.ZaCrf=input.ZaCrf; 
        this.ProvajderID=input.ProvajderID;
        this.OsvezivogStatusa=input.OsvezivogStatusa;
        this.MestoIsporukeRobe=input.MestoIsporukeRobe;
        this.MestoIzvrseneUsluge=input.MestoIzvrseneUsluge;
        this.PakovanjeKolicina = input.PakovanjeKolicina;
        this.PakovanjeVrsta = input.PakovanjeVrsta;
        this.TezinaNeto = input.TezinaNeto;
        this.TezinaNetoJedinicaMereId = input.TezinaNetoJedinicaMereId;
        this.TezinaBruto = input.TezinaBruto;
        this.TezinaBrutoJedinicaMereId = input.TezinaBrutoJedinicaMereId;
        this.Zapremina = input.Zapremina;
        this.ZapreminaJedinicaMereId = input.ZapreminaJedinicaMereId;
        this.BrojPrijemnice = input.BrojPrijemnice;
        this.DatumPrijemnice = input.DatumPrijemnice;
        this.DatumNarudzbenice = input.DatumNarudzbenice;
        this.ReferencaKupcaNaDrugiDokument = input.ReferencaKupcaNaDrugiDokument;
        //this.InterniBrojZaRutiranje = input.InterniBrojZaRutiranje;
        this.KontaktOsoba = input.KontaktOsoba;
        this.KorekcijaVrednostiDokumenta = input.KorekcijaVrednostiDokumenta;
        this.StatusColor = input.StatusColor;
        this.BrojDecimala = input.BrojDecimala;
        this.UkBrPovezanihDokumenata = input.UkBrPovezanihDokumenata;
        // this.UkBrPovezanihDokumenata = null;
        this.DatumUgovora = input.DatumUgovora;
        this.Pozicija = input.Pozicija;
        this.Crm = input.Crm;
        this.Vozac = input.Vozac;
        this.NapomenaTransporteri = input.NapomenaTransporteri;
        this.Komentar = input.Komentar;
        this.VozilaIds = input.VozilaIds;
        this.UkupnoAvansi = input.UkupnoAvansi;
        this.Izvodi = input.Izvodi;
        this.Naplaceno = input.Naplaceno;
        this.zaUplatu = input.zaUplatu;
        this.DatumSmanjenja = input.DatumSmanjenja;    
        this.StatusTooltip = input.StatusTooltip;    
        return this;
    }

    Serialize(input: FakDokument){
        return input;
    }

    GetInstance(){
        return this;
    }
}